<div class="loading-screen-wrapper" *ngIf="loading">
    <div class="loading-screen-icon">
        <p-progressSpinner [style]="{width: '50px', height: '50px'}"
                           styleClass="custom-spinner"
                           strokeWidth="8"
                           fill="#EEEEEE"
                           animationDuration=".5s">
        </p-progressSpinner>
    </div>
    <div class="loading-screen-text">
        <b>{{loadingText}}...</b>
    </div>
</div>
